module.exports = __webpack_public_path__ + "static/img/3.bd2ff7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R407C/3.jpg
// module id = VTbl
// module chunks = 1